import { Employee } from "../models/employee";
import { httpGet } from "./http-client";

const apiUrl = '/api/employees';

export const getEmployees = () => httpGet<Employee[]>(apiUrl);
